import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import StockReport from "./StockReport";
import StockData from "./StockData";
import TrackerData from "./TrackerData";
import { getCurrentUserRole } from "modules/utilities/utility";

function Stock() {
  const [key, setKey] = useState("stock_report");

  return (
    <div className="card bg-white rounded-top pt-2 shadow">
      <Tabs
        id="controlled-tab-example"
        activeKey={key}
        onSelect={(k) => setKey(k)}
      >
        <Tab
          eventKey="stock_report"
          title="Stock Report"
          className="border-bottom border-x p-3"
          style={{height:"80vh"}}
        >
          <StockReport tab={key} />
        </Tab>
        <Tab
          eventKey="stock_data"
          title="Stock Data"
          className="border-bottom border-x p-3"
          style={{minHeight:"80vh"}}
        >
          <StockData />
        </Tab>
       {["admin"].includes(getCurrentUserRole())? <Tab
          eventKey="tracker"
          title="Tracker"
          className="border-bottom border-x p-3"
        >
          <TrackerData tab={key}/>
        </Tab>:null}
        {/* <Tab
          eventKey="extras"
          title="Extras"
          className="border-bottom border-x p-3"
        ></Tab> */}
      </Tabs>
    </div>
  );
}

export default Stock;
